module.exports = __webpack_public_path__ + "img/orange_033.8193f4c8.png";